// ignore-string-externalization

import React from 'react';
import styled from 'styled-components';
import {
  screenSmMax,
  spacer8,
  spacer16,
  spacer24,
} from '@spotify-internal/encore-web';
import { ModuleType } from '../types';
import { ContentfulAsset } from '../../Contentful';
import { FeaturedContentHeadline } from '../../ui';
import { ThreeUpSegment } from './ThreeUpSegment';

const ThreeUp = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${spacer24};

  & h1 {
    padding-top: ${spacer16};
    padding-bottom: ${spacer8};
  }

  @media (max-width: ${screenSmMax}) {
    padding-bottom: ${spacer8};

    [data-aspect-ratio='21x9'] {
      order: 1;
    }
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (max-width: ${screenSmMax}) {
    flex-direction: column;
  }
`;

const SegmentWrapper = styled.div`
  width: 25%;

  @media (max-width: ${screenSmMax}) {
    width: 100%;
  }
`;

type ThreeUpModuleType = ModuleType & {
  headline?: string;
  image?: ContentfulAsset;
  caption?: string;
  segments?: {
    headline?: string;
    body?: string;
    image?: ContentfulAsset;
  }[];
};

export const ThreeUpModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  ThreeUpModuleType
>(({ headline = '', image, caption = '', segments = [] }, ref) => {
  const fchProps = {
    headline,
    image,
    useFeaturedContentHeadline: true,
    caption,
  };
  return (
    <ThreeUp ref={ref as React.RefObject<HTMLDivElement>}>
      <FeaturedContentHeadline {...fchProps} />
      <Bottom>
        {segments.map(segment => (
          <SegmentWrapper key={segment.headline}>
            <ThreeUpSegment threeUpSegment={segment} />
          </SegmentWrapper>
        ))}
      </Bottom>
    </ThreeUp>
  );
});
